// extracted by mini-css-extract-plugin
export default {"label":"hyBh4h","cta":"fr9xud"};